import { render, staticRenderFns } from "./ProjectDocuments.vue?vue&type=template&id=1dde9e6d"
import script from "./ProjectDocuments.vue?vue&type=script&lang=js"
export * from "./ProjectDocuments.vue?vue&type=script&lang=js"
import style0 from "./ProjectDocuments.vue?vue&type=style&index=0&id=1dde9e6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports